export default {
  saveSuccessMsg: '保存成功！',
  changeLanguageTips: '切换语言成功',
  modifyPwdSuccess: '密码修改成功！',
  noFileMsgOrError: '没有文件信息或文件报错',
  immutableInfo: '该学生信息不可修改！',
  unknownError: '未知错误，请联系管理员！',
  expired: '认证已过期',
}
